var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_29766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6C11.7157 6.3493 12.0937 6.80224 12.3541 7.32295C12.6145 7.84366 12.75 8.41783 12.75 9C12.75 9.58217 12.6145 10.1563 12.3541 10.6771C12.0937 11.1978 11.7157 11.6507 11.25 12",
    stroke: "#798399",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2734 3.75C14.0564 4.38274 14.6879 5.18259 15.1218 6.09099C15.5556 6.99939 15.7808 7.99332 15.7808 9C15.7808 10.0067 15.5556 11.0006 15.1218 11.909C14.6879 12.8174 14.0564 13.6173 13.2734 14.25",
    stroke: "#798399",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.2511H3C2.80109 11.2511 2.61032 11.1721 2.46967 11.0315C2.32902 10.8908 2.25 10.7001 2.25 10.5011V7.50114C2.25 7.30223 2.32902 7.11146 2.46967 6.97081C2.61032 6.83016 2.80109 6.75114 3 6.75114H4.5L7.125 3.37614C7.19055 3.24881 7.29949 3.14913 7.43212 3.09511C7.56475 3.04109 7.71233 3.03628 7.84819 3.08157C7.98405 3.12686 8.09923 3.21925 8.17292 3.34204C8.24662 3.46484 8.27395 3.60995 8.25 3.75114V14.2511C8.27395 14.3923 8.24662 14.5374 8.17292 14.6602C8.09923 14.783 7.98405 14.8754 7.84819 14.9207C7.71233 14.966 7.56475 14.9612 7.43212 14.9072C7.29949 14.8531 7.19055 14.7535 7.125 14.6261L4.5 11.2511Z",
    stroke: "#798399",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_29766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume);
export default __webpack_public_path__ + "static/media/icon-volume.1a87434dd580a0876fd229a7f7348260.svg";
export { ForwardRef as ReactComponent };